<template>
  <div class="project-detail-con">
    <ProjectInfo :dataInfo="projectDetail"  />
    <CommentStep
      v-if="commentList.length > 0 && !noFlow"
      :commentList="commentList"
      :taskSaveData="taskSaveData"
      :taskNo="processDetail.process ? processDetail.process.taskNo : 0"
      :status="processDetail.process && processDetail.process.status ? processDetail.process.status: 'done'"
    />
    <!-- 分发记录 -->
    <CommentDept v-if="flowData.length>0" :commentList="flowData"/>
    <YpCommentStep
      ref="ypCommentStep"
      v-if="showYpComp"
      :activityId="presentFlow.historyActivityId"
      :taskNo="processDetail.process ? processDetail.process.taskNo : 0"
      :status="processDetail.process && processDetail.process.status ? processDetail.process.status: 'done'"
      :originCommentList="ypData"
    />
    <!-- 流程记录  -->
    <CommentTable
      v-if="flowData.length>0"
      :flowData="flowData"
    />
    <!-- 流程按钮 -->
    <BottomLine
      :processDetail="processDetail"
      @refreshData="refreshData"
      @flowNext="flowNext"
      @selectDeptNext="selectDeptNext"
    />

  </div>
</template>
<script>
import { addProject, getProjectDetail, determineSubmit, getVirtualId } from "@/api/zs/zs"
import workFlow from "@/mixins/workFlow";
import ProjectInfo from "../components/projectInfo.vue";
import CommentStep from "@/components/workflowComponents/commentStep/zsCommentStep";
import YpCommentStep from "@/components/workflowComponents/commentStep/zsypCommentStep";
import CommentDept from "@/components/workflowComponents/commentStep/zsCommentDept";
import CommentTable from "@/components/workflowComponents/commentTable/commentTable"
import BottomLine from "@/components/workflowComponents/bottomLine/zsBottomLine"
import { mapGetters } from "vuex";
export default {
  name: 'projectFlowDetail',
  mixins: [workFlow],
  data() {
    return {
      flowableId: '',
      projectId: '',
      projectDetail: {},
      // 研判信息
      ypData: ''
    }
  },
  components: {
    ProjectInfo,
    CommentStep,
    YpCommentStep,
    CommentTable,
    CommentDept,
    BottomLine
  },
  computed: {
    ...mapGetters(["ypWorkFlowData"]),
    showYpComp() {
      return (this.presentFlow.historyActivityId && this.presentFlow.historyActivityId == 'Activity_accept_dept_determine') || this.ypData.length > 0
    }
  },
  mounted() {
    this.projectId = this.$route.params.id
    this.refreshData()
  },
  methods: {
    refreshData() {
      // 查询当前项目信息
      this.queryProjectDetail()
    },
    async queryProjectDetail() {
      const res = await getProjectDetail({ id: this.projectId })
      if(res.data.code == 200) {
        this.projectDetail = res.data.data
        this.flowableId = res.data.data.flowableId
        await this.queryFlowData(this.flowableId)
        this.ypData = res.data.data.determineList
      }
    },

    selectDeptNext(dept) {
      // console.info(dept, 'dept')
      this.flowNext(dept)
    },

    async flowNext(dept = '') {
      let processInsId = this.processDetail.process.processInstanceId;
      let taskId = this.processDetail.process.taskId;
      // console.info(this.workFlowData, 'workFlowData')
      const initParams = {
        zs_accept_dept: dept.dictValue,
        zs_accept_dept_name: dept.dictKey
      }
      const variables = dept==''?{}:initParams
      if(this.workFlowData.opinionContent !== '') {
        // 流程表单数据
        await this.zsTaskFlowNext(
          taskId,
          processInsId,
          this.workFlowData.attchmentList ? this.workFlowData.attchmentList : [],
          this.workFlowData.opinionContent ? this.workFlowData.opinionContent : "",
          variables
        );
        // 当前为部门分发的节点
        if(dept !== '') {
          const params = {
            id: this.projectId,
            acceptDept: dept.dictValue
          }
          await addProject(params)
        }
        // 当前为研判节点，判断研判信息是否补全
        if(this.presentFlow.historyActivityId == 'Activity_accept_dept_determine') {
          const ypParams = {
            id: this.processDetail.process.taskNo,
            zsProjectId: this.projectId,
            content: this.ypWorkFlowData.opinionContent
          }
          await determineSubmit(ypParams)
        }
        // 刷新数据
        this.refreshData();
        this.$forceUpdate();
      }else {
        this.$message.warning('请先填写申报审核信息')
      }

    }
  }
}
</script>
<style lang="scss" scoped>
.project-detail-con{
  height: auto !important;
  padding-bottom: 30px !important;
  /deep/.el-dialog {
    border-radius: 8px;
  }  
  /deep/ .el-dialog__header {
    border-radius: 5px 5px 0px 0px !important;
    background-color: rgb(245, 245, 245) !important;
    color: #333 !important;
    border-bottom: 1px solid #e4e4e4e4 !important;
  }
  /deep/ .el-dialog__body {
    padding: 20px 20px 20px !important;
  }  
}
</style>